import styles from './LoadingBackground.module.scss'

const LoadingBackground = () => <div id="Loading" className={styles.root} />

export default LoadingBackground
